import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { initialState } from '@/modules/draw/campaigns/store/campaignSlice/initialState.ts'

const campaignSlice = createSlice({
  name: 'campaign',
  initialState,
  reducers: {
    setIsCreateModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isCreateModalOpen = action.payload
    },
    setEditId: (state, action: PayloadAction<number | null>) => {
      state.editId = action.payload
    },
    setFilters: (state, action: PayloadAction<string>) => {
      state.filters = action.payload
    },
    reset: () => initialState
  }
})

export const campaignActions = campaignSlice.actions
export const { reducer: campaignReducer } = campaignSlice
